/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import {
	Tabs as BaseTabs
} from 'ca-ui-toolkit';

import _ from 'underscore';

@observer
class Tabs extends Component {

	render() {
		const forwardedProps = _.omit(this.props, 'children', 'model');
		const selectedTab = this.props.model.getTab();

		return (
			<div {...forwardedProps} onKeyDown={(e) => this.onKeyDown(e)} >
				<BaseTabs
					selected={selectedTab}
					onChange={tabId => this.onTabChange(tabId)}
				>
					{this.props.children}
				</BaseTabs>
			</div>
		);
	}

	onTabChange(id) {
		this.props.model.showTab(id);
	}

	onKeyDown(event = {}) {
		//Defect 279835: Using Delete key when tabbed above or below the slot deletes whole card
		const shouldHandle = event.key === 'Delete' || event.key === 'Backspace';

		if (shouldHandle){
			//This will be used in the keyDown handler in ExploreContainer
			event.handled = true;
		}
	}

}

Tabs.propTypes = {
	model: PropTypes.object.isRequired,
	children: PropTypes.any,
	onTabChange: PropTypes.func
};

Tabs.defaultProps = {
	children: [],
	onTabChange: () => {}
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/js/components/tabs/Tabs.js